const TYPES = {
  course_sessions: 'CourseSession',
  courses: 'Course',
  initiatives: 'Initiative',
  live: 'Course',
  'on-demand': 'Course',
};

export default (props) => TYPES[props.match.params.type];
